import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

const getUserUnities = async (): Promise<any> => {
  return axios.get(`financial/unities`)
}

export function useGetUserUnities() {
  return useQuery(['get-user-unities'], () => getUserUnities(), {
    onSuccess: (data) => {
      return data
    },
    onError: (error: any) => {
      let msg = 'Não foi possível obter as unidades de negócio.'
      if (error?.response?.data?.message) msg = error?.response?.data?.message

      toast.error(`${msg}`, {
        toastId: 'get-user-unities'
      })
    }
  })
}
